import styled from 'styled-components';
import { getColor } from 'utils';
import { Tag } from 'components/tags/styles';
import constants from 'constants/index';
import { RowMenuItem } from 'pages/ArchVisionAdminDashboard/elements/Jobs/styles';

const light = constants.THEME.LIGHT;

export const TitleRow = styled('div')`
    display: inline-flex;
    align-items: center;
`;

export const UserFilterTag = styled(Tag)`
    margin-left: 0.75rem;
`;

export const NameContainer = styled('div')`
    padding-right: 0.5rem;
`;

export const ThumbnailTitleContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const CategoryHeaderContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
`;

export const DateTimeContainer = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const CategoryHeaderLabel = styled('span')`
    color: ${props => getColor(props, 'onPrimary')};
`;

export const CategoryFilterWrapper = styled('div')`
    position: relative;
    display: inline-flex;
    align-items: center;

    &::after {
        content: '▾';
        position: absolute;
        right: 0.4rem;
        pointer-events: none;
        font-size: 0.75rem;
        color: inherit;
    }
`;

export const CategoryFilterSelect = styled('select')`
    appearance: none;
    border: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
    border-radius: 0.25rem;
    background: transparent;
    color: ${props => getColor(props, 'onPrimary')};
    color-scheme: ${props => props.$selectedTheme === light ? 'light' : 'dark'};
    padding: 0.2rem 1.5rem 0.2rem 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
    min-width: 7.5rem;

    option {
        background-color: ${props => getColor(props, props.$selectedTheme === light ? 'white' : 'darkGrey')};
        color: ${props => getColor(props, 'onPrimary')};
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0.1rem 0.1rem ${props => getColor(props, 'accent')};
    }
`;

export const RowMenuCopyButton = styled(RowMenuItem).attrs({ as: 'button', type: 'button' })`
    width: 100%;
    border: none;
    background: none;
    font-family: inherit;
    cursor: pointer;
`;
